// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import { Link, browserHistory } from 'react-router';
import uid from 'uid';
import RoutedPaginationLinks from 'shared/components/RoutedPaginationLinks';

class IndexPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { patientMembers: null, isFetching: false };
  }

  componentDidMount() {
    this.fetch(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.query !== this.props.location.query) {
      this.fetch(this.props);
    }
  }

  fetch = props => {
    const fetchingId = uid();
    this.setState({ fetchingId });
    api
      .get('/agent_portal/api/patient_members', {
        params: { ...props.location.query },
      })
      .then(response => {
        if (fetchingId === this.state.fetchingId) {
          this.setState({ fetchingId: null, ...response.data });
        }
      });
  };

  render() {
    if (!this.state.patientMembers) return <LoadingContent />;
    return (
      <PresentationComponent
        {...this.state}
        location={this.props.location}
        isFetching={!!this.state.fetchingId}
      />
    );
  }
}

const PresentationComponent = ({
  totalPages,
  patientMembers,
  entityIds,
  string,
  showInactive,
  isFetching,
  location,
}) => (
  <Page
    title="Patients"
    extraTitleContent={
      <Link to="/a/portal/patient_members/new" className="btn btn-primary btn-large">
        New Patient
      </Link>
    }
  >
    <SearchForm searched={!!string} showInactive={showInactive} string={string} />
    <Row>
      <Widget className="nopadding" title="Patients" span={12} isLoading={isFetching}>
        <table className="table table-bordered table-striped table-hover data-table">
          <thead>
            <tr>
              <th>MRN</th>
              <th>Name</th>
              {entityIds.length > 1 && <th>Location</th>}
              <th>DOB</th>
              <th>Primary Phone</th>
              <th>Secondary Phone</th>
              <th>New Referral</th>
            </tr>
          </thead>
          <tbody>
            {patientMembers.map(pm => (
              <tr key={pm.id} id={`patient_${pm.id}`} data-active={pm.patientActiveStatusSymbol}>
                <td>{pm.medicalRecordNumber}</td>
                <td>
                  <Link to={`/a/portal/patient_members/${pm.id}`}>{pm.commaDelimitedName}</Link>
                </td>
                {entityIds.length > 1 && <td>{pm.locationName}</td>}
                <td>{pm.dob}</td>
                <td>{pm.formattedPrimaryPhone}</td>
                <td>{pm.formattedSecondaryPhone}</td>
                <td>
                  <Link
                    to={`/a/portal/referral_profiles/new?existing_patient_id=${pm.patientId}`}
                    className="btn btn-primary btn-mini"
                  >
                    Start New Referral
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Widget>
    </Row>
    <RoutedPaginationLinks totalPages={totalPages} pageParam="page" currentLocation={location} />
  </Page>
);

class SearchForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.search = this.search.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  clearSearch() {
    this.input.value = '';
    this.checkbox.checked = false;
  }

  search(e) {
    e.preventDefault();
    browserHistory.push({
      pathname: '/a/portal/patient_members',
      query: { show_inactive: this.checkbox.checked, string: this.input.value },
    });
  }

  render() {
    /* eslint-disable no-return-assign */
    return (
      <form className="form-inline" onSubmit={this.search}>
        <label>
          Show Inactive{' '}
          <input
            type="checkbox"
            name="show_inactive"
            defaultChecked={this.props.showInactive}
            ref={checkbox => (this.checkbox = checkbox)}
          />
        </label>
        <br />
        <label>
          Name{' '}
          <input
            name="string"
            type="text"
            defaultValue={this.props.string}
            ref={input => (this.input = input)}
          />
        </label>
        &nbsp;
        <button type="submit" className="btn btn-primary">
          Search
        </button>
        &nbsp;
        {this.props.searched && (
          <Link to="/a/portal/patient_members" className="btn btn-info" onClick={this.clearSearch}>
            Clear Search
          </Link>
        )}
      </form>
    );
    /* eslint-enable no-return-assign */
  }
}

export default IndexPage;
